import React from 'react';
import { CSSObject } from 'styled-components';
import {
  CollapsibleWrapperStyled,
  // CollapsibleChildren,
} from './collapsible.styled';

interface CollapsibleProps {
  children?: React.ReactChild | React.ReactChild[];
  width?: number;
  open?: boolean;
  sx?: CSSObject;
}

const Collapsible = ({ children, ...rest }: CollapsibleProps) => {
  return (
    <CollapsibleWrapperStyled {...rest}>{children}</CollapsibleWrapperStyled>
  );
};

Collapsible.defaultProps = {
  open: false,
};

export default Collapsible;
